import React, { useState } from "react";
import Box from "../../../../components/_styles/Box";
import { Card } from "../../../../styles";
import Table from "../../../../components/Table/Table";
import { ReactComponent as EmptyStateImg } from "../../../../assets/empty-state-search.svg";
import { TemplateButton } from "../SmsCreationDialog";
import { EmptyState } from "../../../../components/EmptyState/EmptyState";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_MESSAGES_TEMPLATE_REQUEST,
  getMessagesTemplates,
  updateMessagesTemplates,
} from "../../../../actions/radminUploads";
import LoadMoreButton from "../../../../components/LoadMoreButton";
import styled from "styled-components";
import { styled as materialStyle } from "@material-ui/core/styles";
import { Typography, Grid } from "@material-ui/core";
import Flex from "../../../../components/_styles/Flex";
import TemplateCreationDialog from "./TemplateDialog";

export const Image = styled.img`
  width: 20px;
  margin-right: 7px;
  color: #000000;
  fill: #000000;
`;

export const SmsContent = materialStyle(Typography)({
  color: "#000000",
  fontSize: 14,
  fontWeight: 400,
  padding: "0",
  fontFamily: "Roboto Condensed",
});
const Heading = styled.p`
  font-weight: 700;
  color: #0c2945;
  font-size: 21px;
  font-family: Roboto Condensed;
  line-height: 24px;
  margin: 0;
  text-align: left;
  text-transform: capitalize;
  margin-top: 30px;
`;

export const DatePickerButton = styled(Flex)`
  padding: 13px;
  align-items: center;
  background: #00aeef;
  height: 38px;
  border: none;
  width: 210px;
  border-radius: 4px;
  justify-content: center;
  &:hover {
    cursor: pointer;
    background-color: ${(props) => props.hoverBg || "#0088CC"};
    border: none;
  }
`;

export const DateContainer = styled(Flex)`
  font-size: 14px;
  color: #ffffff;
  font-weight: 600;
  span {
    transition: transform 0.3s ease-in-out;
  }

  &:hover span {
    font-weight: bold;
    transform: scale(1.1);
  }
`;

export const NormalText = materialStyle(Typography)({
  fontSize: 14,
  color: "#3F4857",
  fontFamily: "Roboto Condensed",
  display: "inline",
});
export const PersionalizedTextContainer = materialStyle(Grid)({
  border: "1px solid #CBCCCF",
  borderRadius: "4px",
});

export const PersonalizedInnerContainer = materialStyle(Grid)({
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  height: 38,
});
export const ParagraphContainer = materialStyle(Grid)({
  padding: "5px 10px",
  cursor: "auto",
});
export const SmsInfoContainer = materialStyle(Grid)({
  padding: "0px 10px",
  display: "flex",
});

export const CreateTemplateContainer = materialStyle(Grid)({
  maxHeight: "290px",
});

const faxData = {
  patientMRN: "",
  recommendationAnatomy: "",
  recommendationModality: "",
  recommendationRangeEnd: "",
  recommendationRangeStart: "",
  referringPhysicianFirstName: "",
  referringPhysicianLastName: "",
  patientFirstName: "",
  patientLastName: "",
  initialStudyModal: "",
  initialLocationAddress: "",
  examDate: "",
};

const smsData = {
  patientNameDefaultValue: "",
  referringPhysicianDefaultValue: "",
  referringPhysicianDefaultNumber: "",
  pcpDefaultName: "",
  pcpDefaultNumber: "",
  providerDefaultName: "",
};

const TemplateData = ({
  activeTab,
  titleForSearch,
  page,
  setPage,
  activeSubTab,
  loading,
  setLoading,
}) => {
  const dispatch = useDispatch();
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [openTemplateDialog, setOpenTemplateDialog] = useState(false);
  const [defaultValue, setDefaultValue] = useState(
    activeTab === "fax" ? faxData : smsData
  );

  const columns = [
    ...(activeTab === "fax"
      ? [
          {
            key: "action_id",
            name: "Cover Id",
            align: "left",
            displayCell: (cellValue, rowData) => <div>{cellValue ?? "-"}</div>,
          },
        ]
      : []),
    ...(activeTab !== "fax" &&
    !(activeTab === "sms" && activeSubTab === "manual")
      ? [
          {
            key: "campaign_name",
            name: "Campaign Title",
            align: "left",
            displayCell: (cellValue, rowData) => <div>{cellValue ?? "-"}</div>,
          },
        ]
      : []),
    {
      key: "title",
      name: "Template Name",
      align: "left",
      displayCell: (cellValue, rowData) => <div>{cellValue ?? "-"}</div>,
    },
    ...(activeTab === "email"
      ? [
          {
            key: "editable",
            name: "Editable",
            align: "left",
            displayCell: (cellValue, rowData) => (
              <div>{cellValue ? "true" : "false"}</div>
            ),
          },
        ]
      : []),
  ];

  const smsTemplateList = useSelector((state) => state.radAdmin?.templates);

  const onLoadMore = () => {
    dispatch(
      getMessagesTemplates(page + 1, activeTab, activeSubTab, titleForSearch)
    );
    setPage(page + 1);
  };

  const onSelectTemplate = (template) => {
    setOpenTemplateDialog(true);
    setSelectedTemplate(template);
    function parseString(inputString) {
      const pattern = /{{\s*(.*?)\s*\|\s*default\("(.*?)"\)\s*}}/g;
      const parsedData = {};
      let match;

      while ((match = pattern.exec(inputString)) !== null) {
        const key = match[1];
        const value = match[2];
        parsedData[key] = value;
      }

      return parsedData;
    }
    const parsedData = parseString(template?.message_content);
    if (activeTab === "sms") {
      setDefaultValue({
        patientNameDefaultValue: parsedData?.first_name || "",
        referringPhysicianDefaultValue:
          parsedData?.referring_physician_first_name || "",
        referringPhysicianDefaultNumber:
          parsedData?.referring_physician_phone_number || "",
        pcpDefaultName: parsedData?.primary_care_physician_first_name || "",
        pcpDefaultNumber: parsedData?.primary_care_physician_phone_number || "",
        providerDefaultName: parsedData?.provider_name || "",
      });
    } else if (activeTab === "fax") {
      setDefaultValue({
        patientMRN: parsedData?.patient_mrn || "",
        recommendationAnatomy:
          parsedData?.recommendation_anatomy || "",
        recommendationModality:
          parsedData?.recommendation_modality || "",
        recommendationRangeEnd:
          parsedData?.recommendation_range_end || "",
        recommendationRangeStart:
          parsedData?.recommendation_range_start || "",
        referringPhysicianFirstName:
          parsedData?.referring_physician_first_name || "",
        referringPhysicianLastName:
          parsedData?.referring_physician_last_name || "",
        patientFirstName:
          parsedData?.patient_first_name || "",
        patientLastName:
          parsedData?.patient_last_name || "",
        initialStudyModal:
          parsedData?.initial_study_modality || "",
        initialLocationAddress:
          parsedData?.initial_exam_location_address || "",
        examDate: parsedData?.exam_date || "",
      });
    }
  };

  const onSaveTemplates = async (templateContent) => {
    setLoading(true);
    let dataForTemplate = {};
    if (activeTab === "sms" && activeSubTab === "manual") {
      dataForTemplate.message_content = templateContent;
    } else {
      dataForTemplate.body = templateContent;
      dataForTemplate.campaign_id =
        activeTab === "fax" ? "000" : selectedTemplate?.campaign_id;
      dataForTemplate.action_id = selectedTemplate?.action_id;
    }

    dispatch({ type: GET_MESSAGES_TEMPLATE_REQUEST });
    await dispatch(
      updateMessagesTemplates(
        dataForTemplate,
        activeTab,
        activeSubTab,
        selectedTemplate?.id
      )
    ).then((res) => {
      if (res && res?.status == 200) {
        setOpenTemplateDialog(false);

        dispatch(
          getMessagesTemplates(page, activeTab, activeSubTab, titleForSearch)
        ).then((response) => {
          if (response?.results) {
            setLoading(false);
          }
        });
      } else {
        setLoading(false);
      }
    });
  };

  return (
    <>
      <Box>
        <Heading>{`Saved ${
          activeTab === "sms" ? "SMS" : activeTab
        } Templates`}</Heading>
        <Card>
          <Table
            rows={smsTemplateList?.data && smsTemplateList?.data}
            columns={columns.concat({
              key: "2",
              name: "",
              displayCell: (cellValue, rowData) => (
                <TemplateButton
                  hoverBg={"#06739D"}
                  color={"#ffffff"}
                  isHover={true}
                  title="Select"
                  clickHandler={() => onSelectTemplate(rowData)}
                  style={{ width: "82px" }}
                  textStyles={{ color: "white" }}
                ></TemplateButton>
              ),
              width: "20px",
            })}
            isLoadingRows={loading && smsTemplateList?.isLoading}
            getRowsAction={(pageNumber) =>
              getMessagesTemplates(
                pageNumber,
                activeTab,
                activeSubTab,
                titleForSearch
              )
            }
            noDataRender={() => (
              <EmptyState title={"No Results"} img={() => <EmptyStateImg />}>
                Sorry, there are no results
              </EmptyState>
            )}
          />

          {smsTemplateList?.data && smsTemplateList?.data.length !== 0 && (
            <LoadMoreButton
              title="Load more"
              isLoading={
                smsTemplateList?.isLoading &&
                smsTemplateList?.totalItems !== smsTemplateList?.data.length
              }
              handleClick={onLoadMore}
              isDisabled={
                smsTemplateList?.totalItems === smsTemplateList?.data.length
              }
            />
          )}
        </Card>
      </Box>
      {openTemplateDialog && (
        <TemplateCreationDialog
          openTemplateDialog={openTemplateDialog}
          setOpenTemplateDialog={setOpenTemplateDialog}
          selectedTemplate={selectedTemplate}
          activeTab={activeTab}
          onSaveTemplates={onSaveTemplates}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
        />
      )}
    </>
  );
};

export default TemplateData;
